import { render, staticRenderFns } from "./InstructorRole.vue?vue&type=template&id=a8b8be2e"
import script from "./InstructorRole.vue?vue&type=script&lang=js"
export * from "./InstructorRole.vue?vue&type=script&lang=js"
import style0 from "./InstructorRole.vue?vue&type=style&index=0&id=a8b8be2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports